import '../components.scss';

const Loader = () => {
    return (
        <div className={"loader-wrap"}>
            <div className="loader"></div>
        </div>
    );
};

export default Loader;